import {
  Box,
  Divider,
  IconButton,
  Stack,
  SwipeableDrawer,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export interface MobileDrawerProps {
  open: boolean;
  closeDrawer: () => void;
  openDrawer: () => void;
  title: string;
  children: React.ReactNode;
}

export default function MobileDrawer({
  open,
  closeDrawer,
  openDrawer,
  title,
  children,
}: Readonly<MobileDrawerProps>) {
  const iOS =
    typeof navigator !== 'undefined' &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <SwipeableDrawer
      disableBackdropTransition={!iOS}
      disableDiscovery={iOS}
      anchor='bottom'
      open={open}
      sx={{ zIndex: 1302 }}
      onClose={closeDrawer}
      onOpen={openDrawer}
    >
      <Stack
        direction='row'
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Typography variant='h2' align='left' sx={{ padding: 2 }}>
          {title}
        </Typography>
        <IconButton
          onClick={closeDrawer}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </Stack>
      <Divider />
      <Box
        sx={{
          width: '100%',
          paddingX: 2,
          paddingTop: 3,
        }}
      >
        {children}
      </Box>
    </SwipeableDrawer>
  );
}
